import { XStack, Text, View, useMedia } from 'tamagui'
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome'
import { faCheck } from '@fortawesome/pro-light-svg-icons/faCheck'
import { IProductPage } from '@dtos/ProductPage'
import { useResolvedColors } from './hooks'

// Tópicos (productPage_details_topicsList): check na cor de destaque à
// esquerda; no desktop a linha usa space-between (primeiro à esquerda, meio
// ao centro, último à direita, como no hero_theme), empilhado no mobile.
export function TopicsList({ product }: { product: IProductPage }) {
  const media = useMedia()
  const colors = useResolvedColors()

  if (!product.topics.length) return null

  return (
    <XStack
      marginBottom={64}
      gap={24}
      flexWrap="wrap"
      justifyContent="space-between"
      flexDirection={media.gtSm ? 'row' : 'column'}
      testID="product-topics"
    >
      {product.topics.map((topic) => (
        <XStack
          key={topic.id}
          gap={8}
          alignItems="flex-start"
          maxWidth={media.gtSm ? '33%' : '100%'}
        >
          <View marginTop={5}>
            <FontAwesomeIcon icon={faCheck} size={14} color={colors.accent} />
          </View>
          <Text
            color="$text-primary"
            fontSize={16}
            lineHeight={24}
            fontFamily="$mulishRegular"
            flexShrink={1}
          >
            {topic.description || topic.title}
          </Text>
        </XStack>
      ))}
    </XStack>
  )
}
